import _ from 'lodash';

import { id } from '../utils/helper';

export const SET_CUSTOMER = 'SET_CUSTOMER';

export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCHING_CUSTOMERS = 'FETCHING_CUSTOMERS';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILED = 'FETCH_CUSTOMERS_FAILED';

export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
export const FETCHING_CUSTOMER = 'FETCHING_CUSTOMER';
export const FETCH_CUSTOMER_SUCCESS = 'FETCH_CUSTOMER_SUCCESS';
export const FETCH_CUSTOMER_FAILED = 'FETCH_CUSTOMER_FAILED';

export const SET_LOGO = 'SET_CUSTOMER_LOGO';
export const ADD_CONTACT = 'ADD_CUSTOMER_CONTACT';
export const REMOVE_CONTACT = 'REMOVE_CUSTOMER_CONTACT';
export const ADD_ADDRESS = 'ADD_CUSTOMER_ADDRESS';
export const REMOVE_ADDRESS = 'REMOVE_CUSTOMER_ADDRESS';
export const ADD_TAG = 'ADD_CUSTOMER_TAG';
export const REMOVE_TAG = 'REMOVE_CUSTOMER_TAG';

export function setCustomer(customer) {
  return {
    type: SET_CUSTOMER,
    customer,
  };
}

export function fetchCustomers() {
  return {
    type: FETCH_CUSTOMERS,
  };
}

export function fetchingCustomers() {
  return {
    type: FETCHING_CUSTOMERS,
  };
}

export function fetchCustomersSuccess(customers) {
  return {
    type: FETCH_CUSTOMERS_SUCCESS,
    customers,
  };
}
export function fetchCustomersFailed(error) {
  return {
    type: FETCH_CUSTOMERS_FAILED,
    error,
  };
}

export function fetchCustomer(customerId) {
  return {
    type: FETCH_CUSTOMER,
    customerId,
  };
}

export function fetchingCustomer(customerId) {
  return {
    type: FETCHING_CUSTOMER,
    customerId,
  };
}

export function fetchCustomerSuccess(customer) {
  return {
    type: FETCH_CUSTOMER_SUCCESS,
    customer,
  };
}

export function fetchCustomerFailed(customerId, error) {
  return {
    type: FETCH_CUSTOMER_FAILED,
    customerId,
    error,
  };
}

export function setLogo(customer, logo) {
  return {
    type: SET_LOGO,
    customer,
    logo,
  };
}

export function addContact(customer, contact) {
  return {
    type: ADD_CONTACT,
    customer,
    contact: _.assign({ id: id() }, contact),
  };
}

export function removeContact(customer, contact) {
  console.log('removeContact', contact);
  return {
    type: REMOVE_CONTACT,
    customer,
    contact,
  };
}

export function addAddress(customer, address) {
  return {
    type: ADD_ADDRESS,
    customer,
    address: _.assign({ id: id() }, address),
  };
}

export function removeAddress(customer, address) {
  return {
    type: REMOVE_ADDRESS,
    customer,
    address,
  };
}

export function addTag(customer, tag) {
  return {
    type: ADD_TAG,
    customer,
    tag,
  };
}

export function removeTag(customer, tag) {
  return {
    type: REMOVE_TAG,
    customer,
    tag,
  };
}

// export function saveCustomer(customer) {
//   return {
//     type: SAVE_CUSTOMER,
//     customer,
//   };
// }
//
// export function savingCustomer(customer) {
//   return {
//     type: SAVING_CUSTOMER,
//     customer,
//   };
// }
//
// export function saveCustomerSuccess(customer) {
//   return {
//     type: SAVE_CUSTOMER_SUCCESS,
//     customer,
//   };
// }
// export function saveCustomerFailed(customer,error) {
//   return {
//     type: SAVE_CUSTOMER_FAILED,
//     customer,
//     error,
//   };
// }



// WEBPACK FOOTER //
// ./src/actions/customers.js